module.exports = __webpack_public_path__ + "static/img/blue_animate1.6702aadd.png";